var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6706,
    cy: 24.3919,
    r: 22.2447,
    transform: "rotate(-90 24.6706 24.3919)",
    stroke: "black",
    strokeWidth: 3.05489
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6083 26.8912L27.9928 31.6081C28.7213 32.01 29.2471 31.8019 29.4286 30.9317L32.0274 18.6852C32.2935 17.6185 31.6208 17.1346 30.9238 17.4511L15.6637 23.3353C14.6221 23.7531 14.6282 24.3342 15.4739 24.5931L19.39 25.8154L28.4561 20.0957C28.8841 19.8362 29.2769 19.9757 28.9545 20.2618",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.7382d57b.svg";
export { ForwardRef as ReactComponent };